import React from 'react';
import styles from './index.module.less';
import { Link } from '@base/lib/Link';
import { FeatureContainer } from 'mod/featureV2/FeatureContainer';
import { IFeatureProps } from 'mod/featureV2/interface';
import { IFeatureSGSBanner } from '@pro/brand/interface';
import { HtmlRender } from '@base/snippets/HtmlRender';
import { Banner } from 'mod/featureV2/Banner';
import cn from 'classnames';
import { Button } from '@base/lib/Button';
import { LoopRender } from '@base/snippets/LoopRender';
import { IconPlus } from '@base/icon';
import Tracker from '@base/lib/Tracker';
import { ITrackElementData } from 'base/utils/tracker';
import { getModuleCode } from 'mod/feature/utils';
import { ITextBanner } from 'mod/featureV2/interface/textBanner';

function getAnimateProps(index: number): {
    'data-aos': string;
    'data-aos-once': boolean;
    'data-aos-delay': number;
} {
    return {
        'data-aos': 'fade-up',
        'data-aos-once': true,
        'data-aos-delay': index * 100,
    }
}

export default function FeatureSGSBannerPC(props: IFeatureProps<IFeatureSGSBanner>): Globals.JSXRenderType {
    const { config, list } = props.feature;

    const getTrackData = (item: ITextBanner, index): ITrackElementData => {
        return {
            targetType: 'banner',
            target: item.src,
            relTarget: item.src,
            module: getModuleCode(props.feature),
            position: `${index + 1}`,
        }
    };

    return (
        <FeatureContainer {...props}>
            <div className={styles.wrapper}>
                <LoopRender
                    className={cn(styles.titles, 'flex')}
                    list={list.slice(0, 3)}
                    render={(item, { index, last }) => (
                        <>
                            <div
                                className={cn(styles.item, styles.title, 'flex flex-middle block')}
                                {...getAnimateProps(index)}
                            >
                                <HtmlRender html={item.title}/>
                            </div>

                            {!last && (
                                <div
                                    className={cn(styles.divider, 'flex flex-middle flex-center')}
                                    {...getAnimateProps(index)}
                                >
                                    <IconPlus size={24}/>
                                </div>
                            )}
                        </>
                    )}
                />

                <LoopRender
                    className={'flex'}
                    list={list.slice(0, 3)}
                    render={(item, { index, last }) => (
                        <>
                            <Tracker data={getTrackData(item, index)}>
                                <Link
                                    className={cn(styles.item, 'block')}
                                    hrefEmptyTag={'div'}
                                    href={item.href}
                                    {...getAnimateProps(index)}
                                >
                                    <Banner
                                        banner={{ ...item, href: void 0 }}
                                        width={410}
                                        height={Math.round(410 * config.height / config.width)}
                                        radius={config.radius}
                                    />

                                    <div className={styles.text}>
                                        <HtmlRender className={styles.desc} html={item.description}/>

                                        <Button
                                            className={styles.btn}
                                            {...item.button}
                                        />
                                    </div>
                                </Link>
                            </Tracker>

                            {!last && <div className={styles.divider}/>}
                        </>
                    )}
                />
            </div>
        </FeatureContainer>
    )
}